export default __webpack_public_path__ + "static/media/live-cam.7239e79e.svg";